// extracted by mini-css-extract-plugin
module.exports = {"logoPlaceholder":"style__logoPlaceholder__rhuQd"};